function niceNumbers(number, minimumFractionDigits = 2, maximumFractionDigits = 2) {
    if (number === undefined || number === null) {
      return 'N/A'; 
    }
  
    const formattedNumber = number.toLocaleString(undefined, {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  
    const withoutFraction = formattedNumber.endsWith('.00') ? formattedNumber.split('.')[0] : formattedNumber;
  
    return withoutFraction.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
  const MiniCard = ({ label, value, color }) => (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '8px', backgroundColor: color, color: '#fff', borderRadius: '4px', fontSize: '1.2em', marginBottom: '8px', textAlign: 'center' }}>
      <p style={{ marginBottom: '4px' }}>{label}:</p>
      <strong style={{fontSize: "1.3em"}}>{value}</strong>
    </div>
  );
  
  const BlockCard = ({ title, data, colors }) => (
    <div style={{ textAlign: 'center' }}>
      <div className="text-center" style={{ padding: '16px', marginTop: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '1.5em', zIndex: 1 }}>{title}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
          {data.labels.map((label, index) => (
            <MiniCard key={label} label={label} value={niceNumbers(data.datasets[0].data[index])} color={colors[index]} />
          ))}
        </div>
      </div>
    </div>
  );
  

  export default BlockCard;